module.exports = __webpack_public_path__ + "img/ff5.a0f7972c.jpg";